// Feature: docs/features/icd10-coding-search.md
import React, { useState } from 'react';
import {
  Box,
  Flex,
  Heading,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  VStack
} from '@chakra-ui/react';
import HeaderMenus from '../HeaderMenus';
import CodingSearchCpt from './CodingSearchCpt';
import CodingSearchIcd10 from './CodingSearchIcd10';

const CodingSearch = () => {
  const [mainTabIndex, setMainTabIndex] = useState(0);

  return (
    <Box bg="gray.50" minH="100vh">
      <HeaderMenus />
      <Box p={5}>
        <VStack spacing={6} align="stretch">
          <Flex justify="space-between" align="center">
            <Heading size="lg" color="blue.800">Coding Search & Analysis</Heading>
          </Flex>

          <Box bg="white" borderRadius="md" boxShadow="sm" borderWidth="1px" p={2}>
            <Tabs index={mainTabIndex} onChange={setMainTabIndex} colorScheme="blue" variant="soft-rounded">
              <TabList mb={4}>
                <Tab fontWeight="bold">CPT Rules Analysis</Tab>
                <Tab fontWeight="bold">ICD-10 Medical Necessity</Tab>
              </TabList>

              <TabPanels>
                <TabPanel p={0}>
                  <CodingSearchCpt />
                </TabPanel>
                <TabPanel p={0}>
                  <CodingSearchIcd10 />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Box>
        </VStack>
      </Box>
    </Box>
  );
};

export default CodingSearch;
